import { getServerApi } from '@/gql';
import { ChatSimple } from '@/gql/graph/__generated__/request';
import { useEffect, useState } from 'react';

export interface UseGetChatsByShareIdResult {
    chats: ChatSimple[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<ChatSimple[]>;
}

export const useGetChatsByShareId = (
    shareId: string,
): UseGetChatsByShareIdResult => {
    const [chats, setChats] = useState<ChatSimple[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const getChatsByShareId = async () => {
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.getChatsByShareId({
                shareId,
            });
            if (response?.getChatsByShareId !== undefined) {
                setChats(response.getChatsByShareId);
                return response.getChatsByShareId;
            } else {
                setChats([]);
                return [];
            }
        } catch (err) {
            console.error('Failed to fetch chats by share id:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch chats by share id'),
            );
            setChats([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getChatsByShareId();
    }, []);

    return {
        chats,
        loading,
        error,
        refetch: getChatsByShareId,
    };
};
